import { Deserializable } from '../interfaces';

export class PlanEstudioDTO implements Deserializable {
  clave: string;
  descripcion: string;

  constructor() {
    this.clave = '';
    this.descripcion = '';
  }

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}

